import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './assets/tailwind.css'
import AppRoot from './AppRoot.vue'
import { vScrollAutohide } from './directives/scrollAutohide'
import { useDemoMode } from './composables/useDemoMode'
import { installDemoModeFetch } from './demoMode/fetchInterceptor'
import { installFetchRetry } from './utils/fetchRetry'

installFetchRetry()

// Demo Mode: restore any active session and patch fetch before anything else
// runs, so every subsequent request (including the very first auth check) is
// covered.
useDemoMode().initDemoMode()
installDemoModeFetch()

// Create Vue app
const app = createApp(AppRoot)

// Use Pinia for state management
const pinia = createPinia()
app.use(pinia)

// Use Vue Router
app.use(router)

app.directive('scroll-autohide', vScrollAutohide)

// Wait for router + one paint frame before mounting.
// router.isReady() runs as a microtask (same event-loop tick as JS load),
// so on cached loads it fires before the browser ever paints the spinner.
// requestAnimationFrame delays mount until after the next paint, guaranteeing
// the loading screen is visible for at least one frame.
router.isReady().then(() => requestAnimationFrame(() => app.mount('#app')))

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
}